__turbopack_context__.v({
  "button": "ExpandableImage-module__bTBDfW__button",
  "container": "ExpandableImage-module__bTBDfW__container",
  "img": "ExpandableImage-module__bTBDfW__img",
});
